/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import {
  Button,
  List,
  ListItem,
  Tooltip,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import DragHandleIcon from '@material-ui/icons/DragHandle';

import * as actions from '../../../../state';
import styles from '../styles.module.css';

const messages = defineMessages({
  COLUMNS: {
    id: 'COLUMNS',
    defaultMessage: 'Columns',
  },
  EDIT_COLUMNS: {
    id: 'EDIT_COLUMNS',
    defaultMessage: 'Edit Columns',
  },
  DELETE_COLUMN_TOOLTIP: {
    id: 'DELETE_COLUMN_TOOLTIP',
    defaultMessage: 'Remove this column from the table',
  },
});

function DataSourceColumns({
  dragOver,
  toggleColumns,
}) {
  const dispatch = useDispatch();
  const chartsManifest = useSelector(actions.readChartsManifest);
  const selectedChart = useSelector(actions.readStateSelectedChart);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const columns = selectedChart.data_sources[0].queryParams.stats;
    const column = columns[oldIndex];

    columns.splice(oldIndex, 1);
    columns.splice(newIndex, 0, column);

    selectedChart.data_sources[0].queryParams.stats = columns;

    dispatch(actions.updateSelectedChart({
      ...selectedChart,
      renderRequired: true,
    }));
  };

  const deleteColumn = (stat) => {
    const chart = selectedChart;
    chart.data_sources[0].queryParams.stats.forEach((column, cId) => {
      if (column === stat) { chart.data_sources[0].queryParams.stats.splice(cId, 1); }
    });

    dispatch(actions.updateSelectedChart({
      ...selectedChart,
      renderRequired: true,
    }));
  };

  const statFullName = (statGroup, stat) => {
    const statDef = chartsManifest[selectedChart.type].dataOptions[statGroup];
    return statDef.supportedColumns.find((column) => column.stat === stat).label;
  };

  const source = selectedChart.data_sources[0];

  const DragHandle = SortableHandle(() => <DragHandleIcon className={styles.reorderHandle} />);

  const SortableItem = SortableElement(({ stat, statGroup, sId }) => (
    <ListItem
      key={sId}
      className={`${styles.sourceListItem} ${styles.columnSource}`}
    >
      <DragHandle />
      {statFullName(statGroup, stat)}
      <Tooltip disableFocusListener title={<FormattedMessage {...messages.DELETE_COLUMN_TOOLTIP} />}>
        <DeleteIcon onClick={() => deleteColumn(stat)} className={styles.deleteColumnIcon} />
      </Tooltip>
    </ListItem>
  ));

  const SortableList = SortableContainer(() => (
    <div onDragOver={dragOver}>
      {source.queryParams.stats.map((stat, sId) => (
        <SortableItem
          key={`column-${sId}`}
          index={sId}
          stat={stat}
          statGroup={source.stat}
        />
      ))}
    </div>
  ));

  return (
    <List dense className={styles.menu}>
      <ListItem className={styles.sectionHeader}>
        <FormattedMessage {...messages.COLUMNS} />
      </ListItem>
      <Button
        color="primary"
        onClick={toggleColumns}
        className={styles.addSourceBtns}
      >
        <EditIcon style={{ fontSize: 16, marginLeft: 6, marginRight: 6 }} />
        <FormattedMessage {...messages.EDIT_COLUMNS} />
      </Button>
      <SortableList
        useDragHandle
        items={source.queryParams.stats}
        onSortEnd={onSortEnd}
      />
    </List>
  );
}

export default DataSourceColumns;
